/**
 * To be used in the context of "$XX<billingFrequencyUnit>"
 */
module.exports = function () {
    return function (deliverySaverPlan = {}) {
        if (deliverySaverPlan.BillingFrequencyDays === 0) {
            switch (deliverySaverPlan.BillingFrequencyMonths) {
                case 1: return '/month';
                case 12: return '/year';
                default: return `/${deliverySaverPlan.BillingFrequencyMonths} months`;
            }
        } else if (deliverySaverPlan.BillingFrequencyMonths === 0) {
            switch (deliverySaverPlan.BillingFrequencyDays) {
                case 1: return '/day';
                case 7: return '/week';
                default: return `/${deliverySaverPlan.BillingFrequencyDays} days`;
            }
        }
        return '';
    };
};



// WEBPACK FOOTER //
// ./src/deliverysaver/delivery-saver-billing-frequency-unit.filter.js